const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/675a1bb084c2edec97d644c104dce8e5.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Welcome to <span className="text-yellow-400">OhmEx Electric</span>
          </h1>
          <p className="text-xl md:text-2xl mb-4 font-semibold">
            24x7 Electrical Services in GTA
          </p>
          <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto">
            Professional Panel Upgrades • EV Charger Installation • Potlights Installation
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20would%20like%20to%20get%20a%20free%20estimate%20for%20electrical%20services."
              className="bg-yellow-400 text-black px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-500 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-fill"></i>
              <span>Get Free Estimate</span>
            </a>
            <a
              href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20would%20like%20to%20speak%20with%20you."
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-black transition-colors cursor-pointer whitespace-nowrap inline-flex items-center space-x-2"
            >
              <i className="ri-phone-fill"></i>
              <span>Call Now</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
